import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid, getParam} from '../question-helper';

export enum ToggleSize {
  Standard,
  Small,
  Medium,
  Large
}

@Component({
    selector: 'app-question-toggle-pills',
    templateUrl: './question-toggle-pills.component.html',
    styleUrls: ['./question-toggle-pills.component.scss'],
    standalone: false
})
export class QuestionTogglePillsComponent implements OnInit {

  @Input() question: Question;
  @Input() toggleLabel = 'Lorum Ipsum';
  @Input() displayInline = false;
  @Input() displayInlineSize = ToggleSize.Standard;
  @Output() questionAnswer = new EventEmitter<any>();

  uniqueControlName = `toggle-${newGuid()}`;
  uniqueControlId = `toggle-id-${newGuid()}`;
  toggleSize = ToggleSize;
  skipped = false;
  showSkip = true;
  parameter: any;
  constructor() { }

  ngOnInit(): void {
    try {
      this.parameter = JSON.parse(this.question.parameter);
    } catch (e) { }
    if (getParam(this.parameter, 'show_skip')?.value === '1') {
      this.showSkip = true;
    }
  }

  checkToggle(event: any): void {
    const checked = event?.target?.checked;
    if (this.question) {
      this.question.answer = checked;
      this.questionAnswer.emit(this.question);
    } else {
      this.questionAnswer.emit(checked);
    }
  }
  onSkipChange(): void {
    if (this.skipped) {
      this.question.answer = 'skipped';
    } else {
      this.question.answer = '';
    }
    this.questionAnswer.emit(this.question);
  }

}
